<template>
  <section class="pt-summary" :class="{ desktop: $isDesktop }">
    <slot name="pitch-type-image" />
    <slot name="card-rhs" />

    <div
      v-if="showPitchtypeDetails || $isDesktop"
      class="pt-details"
      :class="{ 'pt-card': !showPitchtypeDetails }"
    >
      <div class="pt-row">
        <pu-category-icons
          :categories="categories"
          class="pitchtype-categories horizontal-spacing"
        />
        <slot name="status-msg" />
      </div>
      <div class="pt-row name">
        <h3 class="pitchtype-name">
          {{ pitchtype.name }}
        </h3>
        <div
          v-if="showPitchtypeDetails"
          class="pt-details-state"
          @click="$emit('click')"
        >
          <slot name="state" :pitchtype="pitchtype" />
        </div>
      </div>
    </div>

    <slot name="pitch-type-attributes" />
  </section>
</template>

<script lang="ts">
import type { PitchTypeWithChargeType } from '../../types'
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import { combineCategories } from '~/utility/pitchtype'

@Component({
  emits: ['click'],
})
class PitchTypeSummary extends Vue {
  @Prop({ required: true, type: Object })
  pitchtype: PitchTypeWithChargeType

  @Prop({ required: true, type: Boolean })
  showPitchtypeDetails: boolean

  @Prop({ default: null })
  pitchtypeIndex: number | null

  get categories() {
    try {
      return combineCategories(
        this.pitchtype.categories,
        this.pitchtype.negativeCategories,
      )
    } catch (e) {
      return []
    }
  }
}

export default toNative(PitchTypeSummary)
</script>

<style scoped>
.pt-summary {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  column-gap: 1em;
  height: 100%;
  width: 100%;
}

.pt-details {
  flex-shrink: 1;
  width: 100%;
  margin-left: 0.75em;
  align-self: center;
}

.pt-row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: end;
}

.pt-row.name {
  margin: 0.4em 0;
  margin: 0.3em 0;
  align-items: flex-start;
  min-height: calc(
    (var(--body) * 1.125) * 1.1 + (var(--tiny) * 1.1) +
      ((var(--body) * 1.125) * 0.3)
  );
}

.pitchtype-categories.category-icons {
  align-items: flex-end;
  display: flex;
  flex-shrink: 0;
  justify-content: flex-start;
}

.pitchtype-categories.category-icons :deep(img) {
  height: 1em;
}

.pt-details-state {
  flex-shrink: 0;
}

.pt-card :deep(.pt-row.name) {
  flex-direction: column;
  align-items: start;
}

.pt-card :deep(.undated-status) {
  margin-top: 0.5em;
  align-items: start;
}

/* desktop & tablet */
.pt-summary.desktop {
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
}

.desktop .pt-row {
  align-items: center;
  justify-content: flex-start;
  column-gap: 1em;
}

.desktop .pt-row.name {
  margin: 0.25em 0 0.5em;
}

.desktop .pitchtype-name {
  font-size: 1em;
  font-weight: bold;
  color: var(--colour-dark-blue);
}
</style>
